// A single "column operator value" condition row within an OperationalCheck,
// with an AND/OR connector dropdown for every condition after the first
// (the first condition's connector is ignored by the backend - see
// OperationalCondition.connector in preflight.py). Mirrors reporting-hub's
// ConditionRow.tsx.

import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

const OPERATORS = ['==', '!=', '>', '>=', '<', '<='];
const CONNECTORS = ['AND', 'OR'];

const ConditionRow = ({ condition, isFirst, onChange, onRemove, canRemove }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.4rem' }}>
    <div style={{ width: '6rem', flexShrink: 0 }}>
      {!isFirst && (
        <Dropdown
          value={condition.connector || 'AND'}
          options={CONNECTORS.map((c) => ({ label: c, value: c }))}
          onChange={(e) => onChange({ connector: e.value })}
          style={{ width: '100%' }}
        />
      )}
    </div>
    <InputText
      value={condition.column}
      onChange={(e) => onChange({ column: e.target.value })}
      placeholder="column"
      style={{ flex: 1 }}
    />
    <Dropdown
      value={condition.operator}
      options={OPERATORS.map((op) => ({ label: op, value: op }))}
      onChange={(e) => onChange({ operator: e.value })}
      style={{ width: '7.5rem' }}
    />
    <InputText
      value={String(condition.value ?? '')}
      onChange={(e) => onChange({ value: e.target.value })}
      placeholder="value"
      style={{ width: '8rem' }}
    />
    {canRemove && (
      <Button icon="pi pi-times" className="p-button-danger p-button-text p-button-sm" onClick={onRemove} aria-label="Remove condition" />
    )}
  </div>
);

export default ConditionRow;
